import React from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import Loader from '../../../../commons/loader';
import { DatePicker, DatetimePicker } from '../../../../commons/controls';
import getTooltip from '../NaptarTooltips';
import CustomTooltip from '../../../../components/Tooltip/CustomTooltip';
import RFForm from '../../../../components/Form/RFForm';
import RFField from '../../../../components/Form/RFField';

export function ModalNaptarDelete(props) {
  const {
    className,
    isOpen,
    onOKClick,
    toggle,
  } = props;
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop="static">
      <ModalHeader>Törlés</ModalHeader>
      <ModalBody>Biztosan törölni szeretnéd ezt az időtartamot?</ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onOKClick}>OK</Button>
        <Button type="button" color="secondary" onClick={toggle}>Mégsem</Button>
      </ModalFooter>
    </Modal>
  );
}

export function ModalNaptar(props) {
  const {
    addNaptar,
    className,
    editNaptar,
    handleDateInputChange,
    handleNaptartipusSelect,
    handleTimeChange,
    handleEsemenytipusSelect,
    state,
    toggle,
    toggleIsmetlodesCheck,
    updateIsmetlodesOption,
    checkDate
  } = props;

  // Igazat ad, ha a hónap utolsó napja a megadott dátum. A new Date(year, month, 0) konstruktor a month-1 hónap utolsó napját adja vissza
  function isLastDay(dateString) {
    let date = new Date(dateString);
    return date.getDate() === new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

  return (
    <Modal isOpen={state.modalNaptar} toggle={toggle} className={className} backdrop="static">
      <RFForm onSubmit={state.insert ? addNaptar : editNaptar}>
        <ModalHeader>Időtartam {state.insert ? 'felvétel' : 'módosítás'}</ModalHeader>
        <ModalBody>
          <div>
            <div>
              <RFField
                label="Naptártípus:"
                name="naptartipus"
                id="naptartipus"
                type="select"
                defaultSelect={<option value='' disabled>Válassz naptártípust...</option>}
                selectOptions={state.naptartipusOptions}
                value={state.naptartipusFilterSelected}
                onChange={handleNaptartipusSelect}
                disabled={!state.insert}
                required
              />
            </div>
          </div>
          <div>
            <div>
              <RFField
                label="Eseménytípus: *"
                name="esemenytipusid"
                id="esemenytipus"
                type="select"
                defaultSelect={<option value={''} disabled>Válassz eseménytípust...</option>}
                selectOptions={state.esemenytipusOptions}
                value={state.esemenytipusFilterSelected}
                errorMessage="Kötelező mező!"
                onChange={(event, id) => { handleEsemenytipusSelect(id); }}
                disabled={!state.naptartipusFilterSelected}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className={state.insert ? "col-md-9" : "col-md-12"}
            >
              <Label for='date'>Dátum: *</Label>
              <DatePicker
                id='date'
                name='date'
                value={state.obj && state.obj.date && new Date(state.obj.date)}
                disabled={!state.insert}
                onChange={(date) => handleDateInputChange('date', date)}
              />
            </div>
            {state.insert ?
              <div className="col-md-3" style={{ margin: 'auto', paddingTop: '20px' }}>
                <RFField
                  label={'Ismétlődés'}
                  type="checkbox"
                  name="ismetlodes"
                  id="ismetlodes"
                  value={state.ismetlodesCheck}
                  onClick={toggleIsmetlodesCheck}
                />
              </div>
              : <div />}
          </div>
          <div className="row">
            <div className="col-md-6">
              <Label for='kezdet'>Intervallum (tól-ig): *</Label>
              <RFField
                type='time'
                id='kezdet'
                name='kezdet'
                time
                formatDate={'HH:mm'}
                value={state.obj && state.obj.kezdet && new Date(state.obj.kezdet)}
                onChange={(d) => { handleTimeChange('kezdet', d) }}
                onBlur={() => checkDate('kezdet')}
              />
            </div>
            <div className="col-md-6" style={{ paddingTop: '29px' }}>
              <RFField
                type='time'
                id='vege'
                name='vege'
                time
                formatDate={'HH:mm'}
                value={state.obj && state.obj.vege && new Date(state.obj.vege)}
                onChange={(d) => { handleTimeChange('vege', d) }}
                onBlur={() => checkDate('vege')}
              />
            </div>
            {state.ismetlodesCheck ?
              <div className="col-md-12" style={{ padding: 0 }}>
                <div className="col-md-12">
                  <div>
                    <RFField
                      label="Gyakoriság: *"
                      name="naptarismetlodesenum"
                      id="naptarismetlodesenum"
                      type="select"
                      defaultSelect={<option value={''} disabled>Válassz gyakoriságot...</option>}
                      selectOptions={state.ismetlodesOptions}
                      onChange={(event, value) => {
                        updateIsmetlodesOption(value);
                      }}
                      errorMessage="Kötelező mező!"
                      required={state.ismetlodesCheck == true}
                    />
                  </div>
                </div>
                {state.ismetlodesSelected == 'NAP' ?
                  <div className="row" style={{ paddingLeft: 13 }}>
                    <div>
                      <RFField
                        label={'Szombattal'}
                        type="checkbox"
                        name="szombat"
                        id="szombat"
                      />
                    </div>
                    <div>
                      <RFField
                        label={'Vasárnappal'}
                        type="checkbox"
                        name="vasarnap"
                        id="vasarnap"
                      />
                    </div>
                  </div>
                  : <div />}
                  {state.ismetlodesSelected == 'HAVI' && state.obj.date && isLastDay(state.obj.date) ?
                  <div className="row">
                    <div
                      style={{ marginLeft: 10 }}
                    >
                      <RFField
                        label={'Hónap utolsó nap'}
                        tooltip={<CustomTooltip text={getTooltip('utolsonap')} id="utolsonapTT" />}
                        type="checkbox"
                        name="utolsonap"
                        id="utolsonap"
                      />
                    </div>
                  </div>
                  : <div />}
                <div className="col-md-12">
                  <Label for='ismetlodesvege'>
                    Ismétlődés vége: *
                    <CustomTooltip text={getTooltip('ismvege')} id="ismvegeTT" />
                  </Label>
                  <DatePicker
                    id='ismetlodesvege'
                    name='ismetlodesvege'
                    onChange={(d) => { handleDateInputChange('ismetlodesvege', d) }}
                  />
                </div>
              </div>
              : <div />}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary">Mentés</Button>{' '}
          <Button type="button" color="secondary" onClick={toggle}>Mégsem</Button>
        </ModalFooter>
      </RFForm>
    </Modal>
  );
}

function renderCard(styleBlock, styleFont, text, iconString, onClick) {
  return (
    <div className="col-md-4 h-100 d-table" style={{ paddingRight: '7px' }} onClick={onClick}>
      <div className="d-table-cell align-middle btn-light" style={styleBlock}>
        <div className="d-flex justify-content-center" style={styleFont}>
          {text}
        </div>
        <div className="d-flex justify-content-center">
          <i className={'fa fa-3x ' + iconString} />
        </div>
      </div>
    </div>
  );
}

function convertDateToString(kezdet, vege) {
  if (kezdet && vege) {
    const options = { hour: '2-digit', minute: '2-digit' };
    const optionsWithYear = { year: 'numeric', month: '2-digit', day: '2-digit', ...options };
    let vegeString = new Date(vege).toLocaleString(undefined, options);
    if (vegeString == '0:00')
      vegeString = '24:00';
    let header = 'Időtartam: ' + new Date(kezdet).toLocaleDateString(undefined, optionsWithYear) + ' - ' + vegeString;
    return header;
  }
  return '';
}

export function ModalNaptarChoice(props) {
  const {
    className,
    deleteNaptar,
    editNaptar,
    viewNaptar,
    isOpen,
    state,
    toggle,
  } = props;
  const styleBlock = {
    border: '1px solid #cfd8dc',
  };
  const styleFont = {
    fontSize: '20px',
    fontWeight: 'bold',
    padding: '5px'
  };
  let header = convertDateToString(state.obj.idokezdet, state.obj.idovege);
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop="static" size='lg'>
      <ModalHeader>
        {header}
      </ModalHeader>
      <ModalBody>
        <div className="row" style={{ height: '200px', padding: '10px' }}>
          {renderCard(styleBlock, styleFont, "Megtekintés", "fa-eye", () => { toggle(); viewNaptar(); })}
          {renderCard(styleBlock, styleFont, "Módosítás", "fa-pencil", () => { toggle(); editNaptar(); })}
          {renderCard(styleBlock, styleFont, "Törlés", "fa-trash", () => { toggle(); deleteNaptar(); })}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="secondary" onClick={toggle}>Mégsem</Button>
      </ModalFooter>
    </Modal>
  );
}

export function ModalNaptarView(props) {
  const {
    className,
    isOpen,
    toggle,
    state,
  } = props;
  let idotartam = convertDateToString(state.obj.idokezdet, state.obj.idovege);
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop="static">
      <ModalHeader>
        Megtekintés
        </ModalHeader>
      <ModalBody>
        {state.loading ? <Loader /> :
          <div>
            <h6>Adatok</h6>
            <b>Időtartam: </b>{idotartam}<br />
            <b>Naptártípus: </b>{state.obj.naptartipusnev}<br />
            <b>Eseménytípus: </b>{state.obj.esemenytipusnev}<br />
          </div>}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>Vissza</Button>
      </ModalFooter>
    </Modal>
  );
}

export function base(props) {
  const {
    className,
    isOpen,
    onOKClick,
    toggle,
  } = props;
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop="static">
      <ModalHeader></ModalHeader>
      <ModalBody>

      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onOKClick}>OK</Button>
        <Button type="button" color="secondary" onClick={toggle}>Mégsem</Button>
      </ModalFooter>
    </Modal>
  );
}